
import { Loader2 } from 'lucide-react';

interface EmailFolderLoadingProps {
  folderName: string;
  isDbReady: boolean;
}

const EmailFolderLoading = ({ folderName, isDbReady }: EmailFolderLoadingProps) => {
  const folderLabels: Record<string, string> = {
    inbox: 'Inbox',
    sent: 'Sent Items',
    drafts: 'Drafts',
    trash: 'Trash'
  };

  console.log(`📧 EmailFolderLoading: Rendering for ${folderName}, isDbReady: ${isDbReady}`);

  return (
    <div className="flex flex-col h-full">
      <div className="border-b p-4 flex items-center justify-between bg-card">
        <div className="flex items-center gap-2">
          <h1 className="font-semibold text-xl">{folderLabels[folderName] || folderName}</h1>
        </div>
      </div>
      
      <div className="flex-1 flex items-center justify-center">
        <div className="flex flex-col items-center gap-4">
          <Loader2 className="h-8 w-8 animate-spin text-primary" />
          <p className="text-sm text-muted-foreground">
            {!isDbReady ? 'Initializing database...' : 'Loading emails...'}
          </p>
          <p className="text-xs text-muted-foreground">
            Debug: isDbReady={String(isDbReady)}
          </p>
        </div>
      </div>
    </div>
  );
};

export default EmailFolderLoading;
